import React from "react";
import { Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const ExpenseAttachmentPreviewDialog = ({ open, onClose, attachment }) => {
  if (!attachment) return null;

  const API_URL = process.env.REACT_APP_API_URL;
  const fileUrl = `${API_URL}${attachment.FileUrl}`;
  const ext = attachment.FileType?.toLowerCase();

  const isImage = ["jpg", "jpeg", "png", "webp"].includes(ext);
  const isPdf = ext === "pdf";

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ display: "flex", justifyContent: "space-between" }}>
        {attachment.OriginalFileName}
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        {isImage && (
          <img
            src={fileUrl}
            alt={attachment.OriginalFileName}
            style={{ width: "100%", maxHeight: "80vh", objectFit: "contain" }}
          />
        )}

        {isPdf && (
          <iframe
            src={fileUrl}
            title={attachment.OriginalFileName}
            width="100%"
            height="600px"
            style={{ border: "none" }}
          />
        )}

        {!isImage && !isPdf && (
          <a href={fileUrl} target="_blank" rel="noopener noreferrer">
            Descargar archivo
          </a>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ExpenseAttachmentPreviewDialog;
